import BaseRepository from "~/repositories/BaseRepository";
import ArticleModel from "@/models/ArticleModel";

class UserAccountArticlesRepository extends BaseRepository {
  async index(params:any = {}) { // eslint-disable-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    const url = "/api/v1/users/user_account_articles";
    const results = await this._get(url, params);
    return results.data.map(article => (new ArticleModel(article)));
  }
}
export default UserAccountArticlesRepository;
